import "./App.css";
import { Route, BrowserRouter, Routes } from "react-router-dom";
import SignIn from "./screens/authenticationPages/signIn";
import ForgotPassword from "./screens/authenticationPages/forgotPassword";
import ResetPassword from "./screens/authenticationPages/resetPassword";
import Overview from "./screens/overview/overview";
import Settings from "./screens/settings/settings";
import Individuals from "./screens/members/individuals";
import Corporate from "./screens/members/corporate";
import DashboardLayout from "./components/dashboardLayout/main";
import AdminRoles from "./screens/settings/adminRoles";
import AdminUsers from "./screens/settings/adminUser";
import AssignPrivileges from "./screens/settings/assignPrivileges";
import ApprovalType from "./screens/settings/approvalType";
import SingleSignOn from "./screens/singleSignOn";
import UploadDocumentSetup from "./screens/settings/uploadDocumentSetup";
import LicenseRenewalSetupFee from "./screens/settings/licenseRenewalSetupFee";
import LicenseRenewalExamsSetup from "./screens/settings/licenseRenewalExamSetup";
import QrCodeTrainingConference from "./screens/Events/qrCodeTraningConference";
import Applicant from "./screens/members/applicant";

import BranchSetup from "./screens/settings/branchSetup";
import ChapterSetup from "./screens/settings/chapterSetup";
import ApprovalSetup from "./screens/settings/approvalSetup";
import ExamSchedule from "./screens/settings/examSchedule";
import EventsDetailsSettings from "./screens/settings/learningTraining/eventDetails";
import TrainingSchedule from "./screens/settings/learningTraining/trainingSchedule";
import EventType from "./screens/settings/learningTraining/eventType";
import EventsSetup from "./screens/settings/learningTraining/eventsSetup";
import ChairmanSetup from "./screens/settings/chairmanSetup";
import InterviewSetup from "./screens/settings/interviewSetup";
import Notifications from "./screens/notification";

import EventDetails from "./screens/Events/eventDetails";
import EventRegister from "./screens/Events/eventRegister";
import UndergraduateRegistration from "./screens/Events/undergradRegistration";

import LicenseRenewalExams from "./screens/Events/licenseRenewalExam";
import AllMembers from "./screens/members/allMembers";

import TransactionHistory from "./screens/transactions/transactionHistory";
import UploadPaymentDues from "./screens/transactions/uploadPaymentDues";
import OutstandingPayment from "./screens/transactions/outstandingPayment";
import DebitNote from "./screens/transactions/debitNote";
import PreviewDebitNote from "./screens/transactions/previewDebitNote";

import {LicenseReports, FirstTimeLicenseApplicantReports,HrLicenseStatusReports,HrWorkActivitiesReports,LicenseReport} from "./screens/report/licenseReports";
import UpgradeMemberReports from "./screens/report/UpgradeReport";
import ChairmanReport from "./screens/report/chairmanReport";
import EndorsementReport from "./screens/report/endorsementReport";
import NonMemberReport from "./screens/report/nonMember";
import BadgeReport from "./screens/report/conferenceBadge";
import DebitNoteReport from "./screens/report/debitNoteReport";

import ProtectedRoute from "./utils/protectedRoute";
import AllApplications from "./screens/applications/allApplication";
import LicenseRenewal from "./screens/applications/licenseRenewal";
import LicenseExamApplication from "./screens/applications/licenseRenewalExam";
import MembershipUpgrade from "./screens/applications/membershipUpgrade";
import PaidUpgradeMember from "./screens/applications/UpgradeMemberLevel";
import ChangeOfName from "./screens/applications/changeOfName";
import ChangeOfMaritalStatus from "./screens/applications/changeMaritalStatus";
import CorporateRevenueUpdate from "./screens/settings/corporateRevenueUpdate";
import CorporateDiscountRate from "./screens/settings/corporateDiscountRate";
import CorporateProfileUpdateChangeOfOfficer from "./screens/applications/corporateProfile/changeOfOfficer";
import CorporateProfileUpdateChangeOfAddress from "./screens/applications/corporateProfile/changeOfAddress";

import EventCategory from "./screens/settings/eventCategory";
import LicenseRegister from "./screens/members/licenseRegister";

import Conference from "./screens/settings/conference";
import LookUp from "./screens/settings/lookup";

import ScoreType from "./screens/settings/score/scoreType";
import ScoreSetUp from "./screens/settings/score/scoreSetUp";
import InvoiceRequest from "./screens/applications/invoiceRequest";
import Activities from "./screens/activities/allActivities";
import EventActivities from "./screens/activities/eventActivities";

import ReadyToMarket from "./screens/readyToMarket";

import Template from "./screens/template";
import ErrorPage from "./components/errorPage/main";
import Messages from "./screens/members/messages";


function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<SignIn />} path="/" />
        <Route element={<ForgotPassword />} path="/forgot-password" />
        <Route element={<ResetPassword />} path="/change-password" />
        <Route element={<SingleSignOn />} path="/single-sign-on" />

        <Route element={<ProtectedRoute />}>
          <Route element={<DashboardLayout />}>
            <Route element={<Notifications />} path="notifications" />
            <Route element={<Overview />} path="/overview" />
            <Route element={<AllMembers />} path="/members/all-members" />
            <Route element={<Individuals />} path="/members/individuals" />
            <Route element={<Corporate />} path="/members/corporate" />
            <Route
              element={<LicenseRegister />}
              path="/members/license-register"
            />
            <Route element={<Applicant />} path="/members/applicants" />
            <Route element={<Messages />} path="/messages" />
          </Route>

          <Route element={<DashboardLayout />}>
            <Route element={<Settings />} path="/settings" />
            <Route element={<AdminUsers />} path="/settings/admin-user" />
            <Route element={<AdminRoles />} path="/settings/admin-roles" />
            <Route
              element={<AssignPrivileges />}
              path="/settings/assign-privileges"
            />
            <Route element={<ScoreSetUp />} path="/settings/score-setup" />
            <Route element={<ScoreType />} path="/settings/score-type" />
            <Route
              element={<UploadDocumentSetup />}
              path="/settings/upload-document-setup"
            />
            <Route
              element={<LicenseRenewalExamsSetup />}
              path="/settings/license-renewal-exams-setup"
            />
            <Route element={<ExamSchedule />} path="/settings/exam-schedule" />
            <Route
              element={<LicenseRenewalSetupFee />}
              path="/settings/setup-fee"
            />
            <Route element={<EventType />} path="/settings/learning-event" />
            <Route element={<EventsSetup />} path="/settings/events-setup" />
            <Route
              element={<EventsDetailsSettings />}
              path="/settings/event-details"
            />
            <Route
              element={<TrainingSchedule />}
              path="/settings/event-schedule"
            />
            <Route element={<BranchSetup />} path="/settings/branch-setup" />
            <Route element={<ChapterSetup />} path="/settings/chapter-setup" />
            <Route
              element={<ChairmanSetup />}
              path="/settings/chairman-setup"
            />
            <Route element={<ApprovalType />} path="/settings/approval-type" />
            <Route
              element={<ApprovalSetup />}
              path="/settings/approval-setup"
            />
            <Route
              element={<InterviewSetup />}
              path="/settings/interview-setup"
            />
            <Route
              element={<CorporateRevenueUpdate />}
              path="/settings/corporate-revenue-update"
            />
            <Route
              element={<CorporateDiscountRate />}
              path="/settings/corporate-discount-rate"
            />
            <Route element={<EventCategory />} path="/settings/event-type" />
            <Route
              element={<Conference />}
              path="/settings/conference-session"
            />
            <Route element={<LookUp />} path="/settings/lookup" />
            <Route element={<Template />} path="/settings/template" />
          </Route>

          <Route element={<DashboardLayout />}>
            <Route element={<EventDetails />} path="/events/events-details" />
            <Route element={<EventRegister />} path="/events/events-register" />
                        <Route element={<UndergraduateRegistration />} path="/events/undergraduate-registration" />

            <Route
              element={<LicenseRenewalExams />}
              path="/events/license-renewal-exams"
            />
            <Route
              element={<QrCodeTrainingConference />}
              path="/events/qr-code-training-conference"
            />
          </Route>

          <Route element={<DashboardLayout />}>
            <Route
              element={<TransactionHistory />}
              path="/transaction/transaction-history"
            />
            <Route
              element={<UploadPaymentDues />}
              path="/transaction/corporate-pending-invoice"
            />
            <Route
              element={<OutstandingPayment />}
              path="/transaction/outstanding-payment"
            />
            <Route element={<DebitNote />} path="/transaction/debit-note" />
            <Route
              element={<PreviewDebitNote />}
              path="/transaction/preview-debit-note"
            />
          </Route>

          <Route element={<DashboardLayout />}>
            <Route
              element={<LicenseReports />}
              path="/reports/license-register"
            />
            <Route
              element={<FirstTimeLicenseApplicantReports />}
              path="/reports/first-license-applicants"
            />
             <Route
              element={<LicenseReport />}
              path="/reports/license-report"
            />
             <Route
              element={<HrWorkActivitiesReports />}
              path="/reports/Hr-work-activities-reports"
            />
             <Route
              element={<HrLicenseStatusReports />}
              path="/reports/hr-license-Status-reports"
            />
            <Route
              element={<UpgradeMemberReports />}
              path="/report/upgrade-register"
            />
            <Route
              element={<ChairmanReport />}
              path="/report/chairman-reports"
            />
            <Route element={<EndorsementReport />} path="/report/endorsement" />
            <Route
              element={<NonMemberReport />}
              path="/report/non-member-organization-reports"
            />
            <Route element={<BadgeReport />} path="/reports/conference-barge" />
            <Route
              element={<DebitNoteReport />}
              path="/report/debit-note-reports"
            />
          </Route>

          <Route element={<DashboardLayout />}>
            <Route
              element={<AllApplications />}
              path="/applications/all-applications"
            />
            <Route
              element={<CorporateProfileUpdateChangeOfOfficer />}
              path="/applications/corporate-profile-update/change-of-officer"
            />
            <Route
              element={<CorporateProfileUpdateChangeOfAddress />}
              path="/applications/corporate-profile-update/change-of-address"
            />

            <Route
              element={<LicenseRenewal />}
              path="/applications/HRPL-activities"
            />
            <Route
              element={<MembershipUpgrade />}
              path="/applications/membership-upgrade"
            />
            <Route
              element={<ChangeOfName />}
              path="/applications/change-of-Name"
            />
            <Route
              element={<ChangeOfMaritalStatus />}
              path="/applications/change-of-marital-status"
            />
            <Route
              element={<InvoiceRequest />}
              path="/applications/invoice-request"
            />
            <Route
              element={<LicenseExamApplication />}
              path="/applications/license-renewal-exam"
            />
            <Route
              element={<PaidUpgradeMember />}
              path="/applications/upgrade-member-level"
            />
            <Route element={<Activities />} path="/activities" />
            <Route element={<EventActivities />} path="/event/activities" />

            <Route element={<ReadyToMarket />} path="/ready-to-market" />
          </Route>
        </Route>

        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
